import React, { useState, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import { message } from "antd";
import { API, BEARER } from "../../constant";
import { getToken } from "../../helpers";
import { removeToken } from "../../helpers";


const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const authToken = getToken();

  const fetchLoggedInUser = async (token) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/users/me`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });

      if (response.status === 401) {
        removeToken()
        window.location.href = '/signin';
      }
      

      const data = await response.json();
      setUserData(data);
    } catch (error) {
      console.error(error);
      message.error("Error While Getting Logged In User Details");
    } finally {
      setIsLoading(false);
    }
  };

  const handleUser = (user) => {
    setUserData(user);
  };

// Ya existente
useEffect(() => {
  if (authToken) {
    fetchLoggedInUser(authToken);
  }
}, [authToken]);

// NUEVO /*
useEffect(() => {
  if (userData?.email === "psanchez@teambike.com") {
    window.location.href = "/catalogo";
  }
}, [userData]);


  return (
    <AuthContext.Provider
      value={{ user: userData, setUser: handleUser, isLoading }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
